import dayjs from "dayjs";

export function test() {
  return null;
}

export const hasNotch = () => {
  // For storybook test
  const storybook = window.location !== window.parent.location;
  const iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
  const aspect = window.screen.width / window.screen.height;
  const aspectFrame = window.innerWidth / window.innerHeight;
  return (
    (iPhone && aspect.toFixed(3) === "0.462") ||
    (storybook && aspectFrame.toFixed(3) === "0.462")
  );
};

export const mergeRefs = (refs) => {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
};

export const randomColor = () => {
  const colors = [
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "danger",
  ];
  const color = Math.floor(Math.random() * colors.length);
  return colors[color];
};

export const priceFormat = (price) => {
  return price.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

export const average = (array) => array.reduce((a, b) => a + b) / array.length;

export const percent = (value1, value2) =>
  Number(((value1 / value2 - 1) * 100).toFixed(2));

export const getFirstLetter = (text, letterCount = 2) =>
  text
    .toUpperCase()
    .match(/\b(\w)/g)
    .join("")
    .substring(0, letterCount);

export const debounce = (func, wait = 1000) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
export const exportToCSV = (columns, data, fileName = "export.csv") => {
  const header = columns.map((col) => col.label).join(",");
  const rows = data.map((row) =>
    columns
      .map((col) => {
        let value;
        if (col.render) {
          value = col.render(row, true); // 👈 tell render to return plain text
        } else {
          value = row[col.key];
        }
        return `"${String(value ?? "").replace(/"/g, '""')}"`;
      })
      .join(",")
  );

  const csvContent = [header, ...rows].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const balanceFormat = (balance) => {
  if (balance === null || balance === undefined) return "";

  // Remove existing commas and any non-numeric characters except dot
  const cleaned = String(balance)
    .replace(/,/g, "")
    .replace(/[^0-9.]/g, "");

  // Convert to number
  const num = parseFloat(cleaned);

  if (isNaN(num)) return ""; // optional: return original value

  return num.toLocaleString("en-AU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const dateFormat = (date, format = "DD-MMM-YYYY") => {
  return dayjs(date).format(format);
};

export const showOrDash = (v) =>
  v === null || v === undefined || v === "" ? "-" : v;

export const isBefore = (date1, date2) => {
  if (!date1 || !date2) return false;
  return new Date(date1) < new Date(date2);
};

export const formatTime = (seconds, format = "mm:ss") => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  const HH = h.toString().padStart(2, "0");
  const MM = m.toString().padStart(2, "0");
  const SS = s.toString().padStart(2, "0");

  switch (format) {
    case "hh:mm:ss":
      return `${HH}:${MM}:${SS}`;

    case "mm:ss":
      return `${MM}:${SS}`;

    case "ss":
      return `${seconds}`;

    case "verbose": // 1h 2m 3s
      return `${h > 0 ? `${h}h ` : ""}${m > 0 ? `${m}m ` : ""}${s}s`.trim();

    default:
      return `${MM}:${SS}`;
  }
};
